// What members call a team: its nickname if it has one, otherwise its official
// name. The server sends it as `display_name`; older cached team objects only
// have `name`. The official name still identifies the team on the Team page,
// the admin site and the data export.
export const teamLabel = (team) =>
  (team && ((team.display_name || "").trim() || team.nickname?.trim() || team.name)) || "";

// True when the team goes by a nickname that differs from its official name.
export const hasNickname = (team) => Boolean(team && team.nickname && team.nickname.trim() && teamLabel(team) !== team.name);
